import { push } from 'connected-react-router';
/* eslint-disable import/no-cycle */
import { routes } from '../app/router/routes';
import { getUserData } from '../user/selectors';

import { setIsShopping } from '../shop/actions';
import { toggleHideDefaultTopNavigation } from '../navigation/actions';

export const routerActions = {
  LOCATION_CHANGE: '@@router/LOCATION_CHANGE'
};

export const routeWithPath = (routes, pathname) => {
  let match = null;

  routes.forEach(route => {
    const routePattern = new RegExp(`${route.path.replace(/:[^\s/]+/g, '([\\w-]+)')}?$`);
    if (routePattern.test(pathname)) match = route;
    if (!match && route.routes) match = routeWithPath(route.routes, pathname);
  });

  return match;
};

export const locationChangeMiddleware = store => next => action => {
  if (action.type === routerActions.LOCATION_CHANGE) {
    const {
      location: { pathname },
      isFirstRendering
    } = action.payload;
    const userData = getUserData(store.getState());
    const currentRoute = routeWithPath(routes, pathname);
    const isShopping = !!(currentRoute && currentRoute.isShopping);
    const isBrowsingAdmin = pathname.startsWith('/admin');

    // Show or hide nav based on route
    store.dispatch(toggleHideDefaultTopNavigation(isBrowsingAdmin));
    store.dispatch(setIsShopping(isShopping));

    if (userData && currentRoute) {
      const { limitToRoles } = currentRoute;

      if (Array.isArray(limitToRoles) && !limitToRoles.includes(userData.role)) {
        // If the user has entered via manual URL insertion or Bookmark
        return isFirstRendering && store.dispatch(push('/'));
      }
    }
  }

  return next(action);
};
